<div *ngIf="canSelectColumns">
    <button (click)="showDefaultColumns()" i18n>Show default columns</button>
    <button (click)="selectColumns()" i18n>Choose which columns to display</button>
</div>
<ub-table [bordered]="true" [striped]="true" rowsize="sm">
    <thead light>
      <tr>
        <th *ngFor="let col of columnsVisible">
          {{ col.label }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of table.data">
        <ng-container *ngIf="!item.row['error']">
          <td *ngFor="let col of columnsVisible; let first = first;">
            <span [style.margin-left.px]="first && item.row.__indent__ !== undefined ? item.row.__indent__ * 30 : 0">
              <ng-container *ngIf="item.row[col.id] != undefined">
                <ng-container [ngSwitch]="col.type">
                  <ng-container *ngSwitchCase="'date'">
                    {{ item.row[col.id] | date }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'dateRange'">
                    {{ item.row[col.id] | easDateRange }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'timeFromNow'">
                    {{ item.row[col.id] | easDateFromNow }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'price'">
                    <span *ngIf="item.row[col.id]">
                      {{ item.row[col.id]['amount'] | currency:item.row[col.id]['currency'] }}
                    </span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'priceRange'">
                    {{ item.row[col.id] | easPriceRange:item.row[col.id].currency }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'datetime'">
                    {{ item.row[col.id] | date:'medium' }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'rate'">
                    {{ item.row[col.id] }}%
                  </ng-container>
                  <ng-container *ngSwitchCase="'link'">
                    <a [routerLink]="[item.row[col.id]?.relative]" [queryParams]="item.row[col.id]?.queryParams">{{ col.label }}</a>
                  </ng-container>
                  <ng-container *ngSwitchCase="'modal'">
                    <button type="button" (click)="openModal(col, item.row[col.id])">{{ col.label }}</button>
                  </ng-container>
                  <ng-container *ngSwitchCase="'button'">
                    <button mat-flat-button color="primary" (click)="onClick(item.row[col.id])">{{ item.row[col.id].label ?? col.label }}</button>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ item.row[col.id] }}
                  </ng-container>
                </ng-container>
              </ng-container>
            </span>
          </td>
        </ng-container>
        <ng-container *ngIf="item.row['error']">
          <td>{{ item.row['error'] }}</td>
        </ng-container>
      </tr>
    </tbody>
</ub-table>
